module.exports = __webpack_public_path__ + "static/media/logo-educandario-default-blue-horizontal.0585f935.png";